/**
 * Reads key/value pairs from URL query string into an object.
 */
export function getDataFromUrl<T>(): T {
  if (typeof location === 'undefined') {
    // on the server, location/URL is undefined
    return {} as T
  }

  const queryPairs = location.search.slice(1).split('&')
  const queryJson: any = {}

  // https://stackoverflow.com/questions/17010119/decodeuri-decodes-space-as-symbol
  function urlDecode(str: string) {
    return decodeURIComponent(str.replace(/\+/g, ' '))
  }

  queryPairs.forEach(pair => {
    const split = pair.split('=')
    queryJson[split[0]] = urlDecode(split[1] || '')
  })

  return queryJson as T
}
